export const ANALYTICS_SIGN_UP = 'ANALYTICS_SIGN_UP';
export const ANALYTICS_PRODUCT_DETAILS_VIEW = 'ANALYTICS_PRODUCT_DETAILS_VIEW';
export const ANALYTICS_ADD_TO_CART = 'ANALYTICS_ADD_TO_CART';
export const ANALYTICS_PRODUCT_REMOVED = 'ANALYTICS_PRODUCT_REMOVED';
export const ANALYTICS_VIEW_CART = 'ANALYTICS_VIEW_CART';
export const ANALYTICS_BEGIN_CHECKOUT = 'ANALYTICS_BEGIN_CHECKOUT';
export const ANALYTICS_PURCHASE = 'ANALYTICS_PURCHASE';
export const ANALYTICS_VIEW_ORDER_DETAILS = 'ANALYTICS_VIEW_ORDER_DETAILS';
export const ANALYTICS_CLEAR_ECOMMERCE = 'ANALYTICS_CLEAR_ECOMMERCE';
export const ANALYTICS_VIEW_CALENDAR_ITEM_LIST = 'ANALYTICS_VIEW_CALENDAR_ITEM_LIST';
export const ANALYTICS_VIEW_LIMITED_ITEM_LIST = 'ANALYTICS_VIEW_LIMITED_ITEM_LIST';
export const ANALYTICS_VIEW_SPECIAL_ITEM_LIST = 'ANALYTICS_VIEW_SPECIAL_ITEM_LIST';
export const ANALYTICS_VIEW_ITEM_LIST = 'ANALYTICS_VIEW_ITEM_LIST';
export const ANALYTICS_SELECT_CALENDAR_ITEM = 'ANALYTICS_SELECT_CALENDAR_ITEM';
export const ANALYTICS_SELECT_LIMITED_ITEM = 'ANALYTICS_SELECT_LIMITED_ITEM';
export const ANALYTICS_SELECT_SPECIAL_ITEM = 'ANALYTICS_SELECT_SPECIAL_ITEM';
export const ANALYTICS_SELECT_ITEM = 'ANALYTICS_SELECT_ITEM';
export const ANALYTICS_SELECT_RELATED_ITEM = 'ANALYTICS_SELECT_RELATED_ITEM';
export const ANALYTICS_PAYMENT_INFO = 'ANALYTICS_PAYMENT_INFO';
export const ANALYTICS_PROFILE_UPDATED = 'ANALYTICS_PROFILE_UPDATED';
export const ANALYTICS_VIEW_PRODUCT_OR_CATEGORY = 'ANALYTICS_VIEW_PRODUCT_OR_CATEGORY';

export function analyticsSignUp(email) {
  return {type: ANALYTICS_SIGN_UP, payload: email};
}

export function analyticsProductDetailsView(product) {
  return {type: ANALYTICS_PRODUCT_DETAILS_VIEW, payload: product};
}

export function analyticsAddToCart(product) {
  return {type: ANALYTICS_ADD_TO_CART, payload: product};
}

export function analyticsProductRemoved(products) {
  return {type: ANALYTICS_PRODUCT_REMOVED, payload: products};
}

export function analyticsViewCart(cart) {
  return {type: ANALYTICS_VIEW_CART, payload: cart};
}

export function analyticsBeginCheckout(cart) {
  return {type: ANALYTICS_BEGIN_CHECKOUT, payload: cart};
}

export function analyticsPurchase(order) {
  return {type: ANALYTICS_PURCHASE, payload: order};
}

export function analyticsClearEcommerce() {
  return {type: ANALYTICS_CLEAR_ECOMMERCE};
}

export function analyticsViewCalendarItemList(taxon, products) {
  return {type: ANALYTICS_VIEW_CALENDAR_ITEM_LIST, payload: {taxon, products}};
}

export function analyticsViewLimitedItemList(taxon, products) {
  return {type: ANALYTICS_VIEW_LIMITED_ITEM_LIST, payload: {taxon, products}};
}

export function analyticsViewSpecialItemList(taxon, products) {
  return {type: ANALYTICS_VIEW_SPECIAL_ITEM_LIST, payload: {taxon, products}};
}

export function analyticsViewItemList(taxon, products) {
  return {type: ANALYTICS_VIEW_ITEM_LIST, payload: {taxon, products}};
}

export function analyticsSelectCalendarItem(taxon, product, index) {
  return {type: ANALYTICS_SELECT_CALENDAR_ITEM, payload: {taxon, product, index}};
}

export function analyticsSelectLimitedItem(taxon, product, index) {
  return {type: ANALYTICS_SELECT_LIMITED_ITEM, payload: {taxon, product, index}};
}

export function analyticsSelectSpecialItem(taxon, product, index) {
  return {type: ANALYTICS_SELECT_SPECIAL_ITEM, payload: {taxon, product, index}};
}

export function analyticsSelectItem(taxon, product, index) {
  return {type: ANALYTICS_SELECT_ITEM, payload: {taxon, product, index}};
}

export function analyticsSelectRelatedItem(relatedProduct, product, index) {
  return {type: ANALYTICS_SELECT_RELATED_ITEM, payload: {relatedProduct, product, index }};
}

export function analyticsPaymentInfo(method, items) {
  return {type: ANALYTICS_PAYMENT_INFO, payload: { method, items }};
}

export function analyticsProfileUpdated(profile) {
  return {type: ANALYTICS_PROFILE_UPDATED, payload: profile};
}

export function analyticsViewOrderDetails(order) {
  return {type: ANALYTICS_VIEW_ORDER_DETAILS, payload: order};
}

export function analyticsViewProductOrCategory(taxon) {
  return {type: ANALYTICS_VIEW_PRODUCT_OR_CATEGORY, payload: taxon};
}



// WEBPACK FOOTER //
// ./middlewares/analytics/actions.js